import { DatastoreInterface } from '@freelancer/datastore/core';
import {
  generateArrayWithValues,
  randomiseList,
} from '@freelancer/datastore/testing';
import {
  OnlineOfflineUserStatus,
  OnlineOfflineUserStatusValue,
} from './online-offline.model';
import { OnlineOfflineCollection } from './online-offline.types';

interface GenerateOnlineOfflineOptions {
  readonly userIds: ReadonlyArray<number>;
  readonly percentOnline?: number;
}

export async function createOnlineOfflines(
  datastore: DatastoreInterface,
  options: GenerateOnlineOfflineOptions,
) {
  const objects = generateOnlineOfflineObjects(options);
  await Promise.all(
    objects.map(object =>
      datastore.createRawDocument<OnlineOfflineCollection>(
        'onlineOffline',
        object,
      ),
    ),
  );

  return objects;
}

function generateOnlineOfflineObjects({
  userIds,
  percentOnline = 50,
}: GenerateOnlineOfflineOptions): ReadonlyArray<OnlineOfflineUserStatus> {
  // Generate a third of the reviews as blank ones.
  const numberOnline = Math.floor((userIds.length * percentOnline) / 100);

  const statuses = randomiseList(
    [
      ...generateArrayWithValues(
        numberOnline,
        OnlineOfflineUserStatusValue.ONLINE,
      ),
      ...generateArrayWithValues(
        userIds.length - numberOnline,
        OnlineOfflineUserStatusValue.OFFLINE,
      ),
    ],
    'onlineOfflineStatuses',
  );

  return userIds.map((freelancerId, i) => ({
    id: freelancerId,
    status: statuses[i],
  }));
}
